import React from 'react';
import './planPricingLoader.scss';

const PlanPricingLoader = () => {
  return (
    <div className="plan_pricing_loader">
      <div className="container">
        <div className="accordion-card">
          <div class="shimmer_box">
            <div className="card_content">
              <div class="box_inside">
                <div class="heading">
                  <span class="visual"></span>
                </div>
                <div className="filed_section">
                  <div className="row">
                    <div className="flg-lg-2 flg-md-2 flg-sm-12">
                      <div class="text text_l">
                        <span class="visual"></span>
                      </div>
                    </div>
                    <div className="flg-lg-2 flg-md-2 flg-sm-12">
                      <div class="text text_l">
                        <span class="visual"></span>
                      </div>
                    </div>
                    <div className="flg-lg-2 flg-md-2 flg-sm-12">
                      <div class="text text_l">
                        <span class="visual"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item_conetents">
                  <div class="text text_l">
                    <span class="visual"></span>
                  </div>
                  <div class="text text_m">
                    <span class="visual"></span>
                  </div>
                </div>
                <div className="comment_conetents">
                  <div class="text text_m">
                    <span class="visual"></span>
                  </div>
                  <div class="text text_l">
                    <span class="visual"></span>
                  </div>
                </div>
                <div className="attach_conetents">
                  <div class="text text_m">
                    <span class="visual"></span>
                  </div>
                  <div class="text text_l">
                    <span class="visual"></span>
                  </div>
                </div>
                <div class="content">
                  <div class="text">
                    <span class="visual circle"></span>
                  </div>
                  <div class="text">
                    <span class="visual circle"></span>
                  </div>
                  <div class="text">
                    <span class="visual circle"></span>
                  </div>
                  <div class="text">
                    <span class="visual circle"></span>
                  </div>
                </div>
                <div class="heading heading_2">
                  <span class="visual"></span>
                </div>
                <div className="item_conetents">
                  <div class="text text_l">
                    <span class="visual"></span>
                  </div>
                  <div class="text text_m">
                    <span class="visual"></span>
                  </div>
                </div>
                <div class="content_items button">
                  <div class="text text_m">
                    <span class="visual"></span>
                  </div>
                  <div class="text text_m">
                    <span class="visual"></span>
                  </div>
                </div>
              </div>
            </div>
            <div className="card_footer">
              <div class="text">
                <span class="visual"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanPricingLoader;
